import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IDebugService = ( createDecorator('debugService'));
export { IDebugService };
